import React from 'react';

import PropTypes from 'prop-types';
import { Accordion, Typography } from '@telus-uds/components-web';

import {
  AddDetailsFormFuelGauge,
  AddDetailsFormFuelPressure,
  AddDetailsFormPropane
} from './components/addDetailsForm';
import InfoList from './components/infoList';

const TankDetailsFarmAndRanch = ({
  tankDetailsFarmAndRanch,
  setTankDetailsFarmAndRanch,
  error
}) => {
  const containerStyles = {
    border: '1px solid',
    borderColor: error ? '#c12335' : '#e3e3e3',
    padding: '1.5rem'
  };

  return (
    <Accordion tag="h2">
      <Accordion.Panel
        id="tankDetails-Fuel-Gauge"
        control={
          <Typography variant={{ bold: true }}>
            TELUS Farm Fuel Mgmt – Fuel Gauge with Float Arm (Gas or Diesel)
          </Typography>
        }
      >
        <div style={containerStyles}>
          <AddDetailsFormFuelGauge
            tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
            setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
            sectionError={error}
          />
          {tankDetailsFarmAndRanch.fuelGauge.length > 0 && (
            <InfoList
              typeKey="fuelGauge"
              tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
              setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
            />
          )}
        </div>
      </Accordion.Panel>
      <Accordion.Panel
        id="tankDetails-Fuel-Pressure"
        control={
          <Typography variant={{ bold: true }}>
            TELUS Farm Fuel Mgmt – Fuel Pressure
          </Typography>
        }
      >
        <div style={containerStyles}>
          <AddDetailsFormFuelPressure
            tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
            setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
            sectionError={error}
          />
          {tankDetailsFarmAndRanch.fuelPressure.length > 0 && (
            <InfoList
              typeKey="fuelPressure"
              tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
              setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
            />
          )}
        </div>
      </Accordion.Panel>
      <Accordion.Panel
        id="tankDetails-Propane"
        control={
          <Typography variant={{ bold: true }}>
            TELUS Farm Propane Mgmt – Propane
          </Typography>
        }
      >
        <div style={containerStyles}>
          <AddDetailsFormPropane
            tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
            setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
            sectionError={error}
          />
          {tankDetailsFarmAndRanch.propane.length > 0 && (
            <InfoList
              typeKey="propane"
              tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
              setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
            />
          )}
        </div>
      </Accordion.Panel>
    </Accordion>
  );
};

TankDetailsFarmAndRanch.propTypes = {
  tankDetailsFarmAndRanch: PropTypes.shape({
    fuelGauge: PropTypes.arrayOf(PropTypes.shape({})),
    fuelPressure: PropTypes.arrayOf(PropTypes.shape({})),
    propane: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  setTankDetailsFarmAndRanch: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankDetailsFarmAndRanch;
